// zone.js 0.9.1 sustituye window.Promise por ZoneAwarePromise, que no implementa allSettled,
// y descarta el polyfill cargado antes que zone.js. PDF.js 2.5 lo usa en el hilo principal.
// Se instala sobre la Promise que haya al ejecutarse, sin reemplazarla ni alterar otros métodos.
export function installPromiseAllSettled(promiseCtor: any): void {
    if (!promiseCtor || typeof promiseCtor.allSettled === 'function') { return; }
    const allSettled = (values: Iterable<any>) => {
        let items: any[];
        try { items = Array.from(values); } catch (error) { return promiseCtor.reject(error); }
        return promiseCtor.all(items.map(item => promiseCtor.resolve(item).then(
            value => ({ status: 'fulfilled', value }),
            reason => ({ status: 'rejected', reason }))));
    };
    Object.defineProperty(promiseCtor, 'allSettled', { value: allSettled, writable: true, configurable: true });
}
